import { render, staticRenderFns } from "./Wp_search_page.vue?vue&type=template&id=40ae69f0&scoped=true&"
import script from "./Wp_search_page.vue?vue&type=script&lang=js&"
export * from "./Wp_search_page.vue?vue&type=script&lang=js&"
import style0 from "./Wp_search_page.vue?vue&type=style&index=0&id=40ae69f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ae69f0",
  null
  
)

export default component.exports